import { ResultApiResponse } from 'lib-shared-types-api';

import { api } from 'app/app.api';

import {
  DeleteFacebookPageApiArg,
  DeleteInstagramAccountApiArg,
  ReadApplicationsApiResponse,
  UpdateFacebookConnectApiArg,
  UpdateFacebookPageApiArg,
  UpdateInstagramAccountApiArg,
} from './types/facebookMessengerApi.types';

export const facebookMessengerApi = api
  .enhanceEndpoints({
    addTagTypes: ['facebook'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      readApplications: builder.query<ReadApplicationsApiResponse, void>({
        query: () => ({
          version: 1,
          path: 'facebook-messenger/applications',
        }),
        providesTags: [{ type: 'facebook', id: 'LIST' }],
      }),
      deleteFacebookPage: builder.mutation<
        ResultApiResponse,
        DeleteFacebookPageApiArg
      >({
        query: ({ pageId }) => ({
          version: 1,
          path: `facebook-messenger/pages/${pageId}`,
          method: 'DELETE',
        }),
        invalidatesTags: [{ type: 'facebook', id: 'LIST' }],
      }),
      updateFacebookPage: builder.mutation<
        ResultApiResponse,
        UpdateFacebookPageApiArg
      >({
        query: ({ pageId, name, queueId }) => ({
          version: 1,
          path: `facebook-messenger/pages/${pageId}`,
          method: 'PUT',
          body: {
            name,
            queue_id: queueId,
          },
        }),
        invalidatesTags: [{ type: 'facebook', id: 'LIST' }],
      }),
      updateFacebookConnect: builder.mutation<
        ResultApiResponse,
        UpdateFacebookConnectApiArg
      >({
        query: (body) => ({
          version: 1,
          path: 'facebook-messenger/connect',
          method: 'PUT',
          body,
        }),
        invalidatesTags: [{ type: 'facebook', id: 'LIST' }],
      }),
      updateInstagramAccount: builder.mutation<
        ResultApiResponse,
        UpdateInstagramAccountApiArg
      >({
        query: ({
          accountId,
          data: {
            name,
            queueId: queue_id,
            isStoryCommentsEnabled: story_comments_enabled,
            isStoryMentionsEnabled: story_mentions_enabled,
          },
        }) => ({
          version: 1,
          path: `facebook-messenger/instagram/account/${accountId}`,
          method: 'PUT',
          body: {
            name,
            queue_id,
            ...((typeof story_comments_enabled !== 'undefined' ||
              typeof story_mentions_enabled !== 'undefined') && {
              messaging_settings: {
                story_comments_enabled,
                story_mentions_enabled,
              },
            }),
          },
        }),
        invalidatesTags: [{ type: 'facebook', id: 'LIST' }],
      }),
      deleteInstagramAccount: builder.mutation<
        ResultApiResponse,
        DeleteInstagramAccountApiArg
      >({
        query: ({ accountId }) => ({
          version: 1,
          path: `facebook-messenger/instagram/account/${accountId}`,
          method: 'DELETE',
        }),
        invalidatesTags: [{ type: 'facebook', id: 'LIST' }],
      }),
    }),
  });
